module.exports = __webpack_public_path__ + "img/patient-card-tabs-mobile-ru.64779414.jpg";